/**
 * Newsletter Service - Lambda Backend Version
 * 
 * Uses the same Lambda function as contact form
 * Just different email type
 */

const EMAIL_SERVICE_URL = process.env.REACT_APP_EMAIL_SERVICE_URL;

/**
 * Send newsletter subscription confirmation email
 * @param {Object} params - Subscriber data
 * @param {string} params.name - Subscriber's name
 * @param {string} params.email - Subscriber's email
 */
export const sendNewsletterConfirmation = async ({ name, email }) => {
    try {
        if (!EMAIL_SERVICE_URL) {
            throw new Error('Email service is not configured. Please contact the administrator.');
        }

        console.log('Sending newsletter confirmation via Lambda...');

        const response = await fetch(EMAIL_SERVICE_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                type: 'newsletter_confirmation',
                name,
                email
            })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Failed to send confirmation email');
        }

        console.log('Newsletter confirmation sent successfully:', data.messageId);
        return { success: true, messageId: data.messageId };

    } catch (error) {
        console.error('Error sending newsletter confirmation:', error);
        throw new Error(error.message || 'Failed to send confirmation email. Please try again.');
    }
};

/**
 * Subscribe to newsletter (DynamoDB + Email)
 * @param {Object} params - Subscription data
 * @param {string} params.email - Subscriber's email
 * @param {string} params.name - Subscriber's name (optional)
 */
export const subscribeToNewsletter = async ({ email, name = 'Subscriber' }) => {
    try {
        // Note: This still uses direct DynamoDB access for now
        // You can move this to Lambda later if needed
        
        // For now, just send the confirmation email via Lambda
        // DynamoDB logic stays in the component
        
        await sendNewsletterConfirmation({ name, email });
        
        return { success: true };
    } catch (error) {
        console.error('Error in newsletter subscription:', error);
        throw error;
    }
};

/**
 * Validate email service configuration
 * @returns {Object} Configuration status
 */
export const validateNewsletterServiceConfig = () => {
    const isConfigured = !!EMAIL_SERVICE_URL;
    
    return {
        isConfigured,
        url: isConfigured ? EMAIL_SERVICE_URL : null,
        message: isConfigured 
            ? 'Newsletter service is properly configured' 
            : 'Email service URL is missing in environment variables'
    };
};
